import { createGlobalStyle } from "styled-components";
export const GlobalStyles = createGlobalStyle`

body{
  --orange: #ff9b30;
  --yellowOrange: #ffb939;
  --black: #000000;
  --grayBlack: #302f2f;
  --white: #ffffff;
  --whiteGray: rgb(238, 238, 238);
  --lightGray: #aeb0b4;
  --darkGray: #767779;
  --Gray: #636364;
  --fontFamily: "Source Sans Pro", sans-serif;
  --lightFont: 300;
    --regularFont: 400;
  --boldFont: 600;
  --blackFont: 900;
  --scriptFont: 'Caveat', cursive;
  outline: 0;
  border: 0;
  box-sizing: border-box;
    margin:0;
    padding:0;
    overflow:hidden;
    a {
  text-decoration: none;
}
ul {
  list-style: none;
}
button {
  cursor: pointer;
}
}

`;
